import { qs, remove } from "@fluorescent/dom";

import ProductItem from "@/lib/product-item";

const selectors = {
  recommendedProductsSidebar: "[data-product-sidebar-recommendations]",
  recommendedProductsContent: "[data-product-sidebar-recommendations-content]",
  recommendedProducts: "[data-product-sidebar-recommendations-products]",
  sidebarItems: "[data-details-sidebar-items]",
  miniItems: ".product__sidebar-recommendations-mini-desktop",
};

const classes = {
  hasSidebar: "product--has-sidebar",
};

const sidebarRecommendations = node => {
  const recommendedProductsSidebar = qs(
    selectors.recommendedProductsSidebar,
    node
  );
  const recommendedProductsContent = qs(
    selectors.recommendedProductsContent,
    node
  );
  const sidebarItems = qs(selectors.sidebarItems, node);

  if (!recommendedProductsSidebar) return;

  let productItems = [];

  const {
    productId: id,
    sectionId,
    maxRecommendations,
  } = recommendedProductsSidebar.dataset;

  handleRecommendedProducts();

  function handleRecommendedProducts() {
    const requestUrl = `${window.theme.routes.productRecommendations}?section_id=${sectionId}&limit=${maxRecommendations}&product_id=${id}`;

    fetch(requestUrl)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement("div");
        html.innerHTML = text;

        const content = qs(selectors.recommendedProductsContent, html);
        const recommendations = qs(selectors.recommendedProducts, html);

        if (recommendations && recommendations.innerHTML.trim().length) {
          recommendedProductsContent.innerHTML = content.innerHTML;

          productItems.push(ProductItem(recommendedProductsContent));

          // Inject content within product meta if enabled. Only visible
          // above certain screen widths.
          if (sidebarItems) {
            const miniItems = qs(selectors.miniItems, recommendations);
            sidebarItems.appendChild(miniItems);

            productItems.push(ProductItem(sidebarItems));
          }

          // Remove hidden flag as content has been fetched
          remove(recommendedProductsSidebar, "hidden");
        } else {
          remove(node, classes.hasSidebar);
          remove(sidebarItems.parentNode, "visible");
        }
      })
      .catch(error => {
        throw error;
      });
  }

  function unload() {
    productItems.forEach(item => item.unload());
  }

  return { unload };
};

export default sidebarRecommendations;
